const $ = jQuery.noConflict();

class Slider {
    constructor(sel, fade = false, num = 1, tabNum = 1, slideSpeed = 600, variableWidth = false) {
        this.selector = sel;
        this.num = num;
        this.tabNum = tabNum;
        this.variableWidth = variableWidth;
        this.slideSpeed = slideSpeed;
        this.fade = fade;
    }
    init() {
        const {
            selector,
            num,
            fade,
            tabNum,
            slideSpeed,
            variableWidth,
        } = this;

        function slideSettings() {
            const el = $(this);
            el.slick({
                dots: false,
                arrows: false,
                infinite: true,
                autoplay: true,
                autoplaySpeed: 4000,
                slidesToShow: num,
                slidesToScroll: 1,
                variableWidth,
                fade,
                pauseOnHover: false,
                speed: slideSpeed,
                responsive: [
                    {
                        breakpoint: 991,
                        settings: {
                            slidesToShow: tabNum,
                            slidesToScroll: 1,
                        },
                    },
                    {
                        breakpoint: 767,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                        },
                    },
                ],
            });
        }
        $(selector).each(slideSettings);
        $('#landing-banner').on('click', function(){
            $(selector).slick('next');
        });
    }
}
const landingSlider = new Slider('.image-wrapper-desktop, .image-wrapper-mobile');

export {landingSlider};
